<template>
  <section v-bind="$attrs" class="relative bg-gray-900">

    <div class="md:hidden relative z-0">
      <div class="absolute z-10 h-48 w-full bottom-0 bg-gradient-to-t from-gray-900 to-transparent"></div>
      <img
        v-if="mobile"
        class="lazy object-cover w-full h-full max-w-7xl"
        :class="mobile.class"
        :style="mobile.style"
        :data-src="mobile.url"
        :height="mobile.height"
        :width="mobile.width"
        :alt="mobile.metadata?.alt ?? alt"
      >
    </div>

    <div class="hidden md:flex absolute inset-0 z-0 before:w-[calc((100%-72rem)/2)]">
      <div class="flex-none w-80"></div>
      <div class="flex-1 relative bg-gray-800">
        <div class="absolute z-10 h-full w-96 left-0 bg-gradient-to-r from-gray-900 to-transparent"></div>
        <img
          v-if="desktop"
          class="lazy object-cover w-full h-full max-w-7xl"
          :class="desktop.class"
          :style="desktop.style"
          :data-src="desktop.url"
          :height="desktop.height"
          :width="desktop.width"
          :alt="desktop.metadata?.alt ?? alt"
        >
      </div>
    </div>

    <div class="container relative">
      <div class="text-white py-10 md:py-24 max-w-md">
        <slot name="default" />
      </div>
    </div>

  </section>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    desktop: {
      type: Object,
      required: false,
    },
    mobile: {
      type: Object,
      required: false,
    },
    alt: {
      type: String,
      required: false,
    },
  },
}
</script>
